import React from 'react';
import styled from 'styled-components';
import SGBody from 'components/Typography/SGBody';
import DeviceType, {DeviceTypeString} from 'features/POSRegisters/interfaces/DeviceType';

const StyledMessage = styled(SGBody)`
  text-align: center;
  padding: 16px;
`;

interface UnsupportedDeviceMessageProps {
  deviceType: DeviceType | null;
}

function formatDeviceString(deviceType: DeviceType): string {
  return `${DeviceTypeString[deviceType]}s`;
}

export default function UnsupportedDeviceMessage({deviceType}: UnsupportedDeviceMessageProps) {
  if (!deviceType) {
    return (
      <StyledMessage variant="b4">
        Nothing to show here. This device is not supported in this tool for this country.
      </StyledMessage>
    );
  }

  const deviceTypeString = formatDeviceString(deviceType);

  return (
    <StyledMessage variant="b4">
      Nothing to show here. {deviceTypeString} are not supported in this tool for this country.
    </StyledMessage>
  );
}
